export const REQUEST_SITEMAP_DATA = 'REQUEST_SITEMAP_DATA';
export const RECEIVE_SITEMAP_DATA = 'RECEIVE_SITEMAP_DATA';

export const receiveSitemapData = (payload) => ({
    type: RECEIVE_SITEMAP_DATA,
    payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/sitemapActions.js